export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/field/index.js